import React from 'react';
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import 'react-tooltip/dist/react-tooltip.css'

createRoot(document.getElementById("root")).render(<App />);
